import { type ComponentProps, createElement } from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { LinkStyled } from '@core/Components/Links'
import { Text } from '@core/Components/Text'

const RacePromotionTextBase = styled(Text)({
  lineHeight: 1.1818,
  margin: 0,
})

export const RacePromotionTextStyled = ({
  as = 'p',
  size = 'sm',
  ...props
}: ComponentProps<typeof RacePromotionTextBase>) =>
  createElement(RacePromotionTextBase, { as, size, ...props })

export const ExternalLinkStyled = styled(LinkStyled)({
  alignItems: 'center',
  color: hexColors.studio,
  display: 'inline-flex',
  marginTop: '0.5em',

  '> svg': {
    marginLeft: '0.25em',
  },
})
